<template>
  <vx-card title="Bonos de ImpactaMas">
    <vs-table :data="bonus">

      <template slot="thead">
        <vs-th>ID</vs-th>
        <vs-th>TXR</vs-th>
        <vs-th>Monto</vs-th>
        <vs-th>Concepto</vs-th>
        <vs-th>Referencia</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Creado</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="b in data" v-bind:key="b.id">
          <vs-td>{{ b.id }}</vs-td>
          <vs-td>{{ b.trxType }}</vs-td>
          <vs-td>{{ b.amount|currency }}</vs-td>
          <vs-td>{{ b.concept }}</vs-td>
          <vs-td>{{ b.reference }}</vs-td>
          <vs-td>{{ b.status }}</vs-td>
          <vs-td>{{ b.createdAt|_humanizeDate }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import {_humanizeDate} from "@/filters/momentTzConvert";

export default {
  name: "ImpactaMasBonusTable",
  props: {
    bonus: {
      type: Array,
      required: true
    }
  },
  filters: {
    _humanizeDate
  },
  methods: {
    percentage(val) {
      return ((val / this.project.finance.total_cost) * 100).toFixed(2)
    }
  }
}
</script>

<style scoped>

</style>
